import styled from "styled-components";


export const ProceedButton = styled.button`
background-color: ${(props) => props.theme.colors.bgColor};
color: ${(props) => props.theme.colors.txtColor};
`;